var React = require('react');

function TriangleLeftConversationalApps (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M116.95 93.944L119.719 199.014L0.997885 83.6527L116.95 93.944Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M198.919 54.1285L119.583 199.083L116.863 94.1483L198.919 54.1285Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M198.918 54.1279L116.92 94.1196L1.00045 83.6531L198.918 54.1279Z","fill":"#5915C7","key":2})]);
}

TriangleLeftConversationalApps.defaultProps = {"width":"241","height":"224","viewBox":"0 0 241 224","fill":"none"};

module.exports = TriangleLeftConversationalApps;

TriangleLeftConversationalApps.default = TriangleLeftConversationalApps;
